// USE MORE VERSATILE mapEnabledToKey INSTEAD
// KEEPING THIS FILE FOR DEPRECATION PURPOSES FOR NOW

/**
 * Maps objects with an enabled boolean key value from an array to a new array containing slug key values
 * @example
 * let arr = [{ enabled: true, slug: 'example-one' }, { enabled: false, slug: 'example-two' }];
 * mapEnabledToSlug(arr)
 * @param {Array} arr - The array of objects to filter and map
 *   @param {Object} arr.obj - An object containing an item to be filtered
 *     @param {Boolean} arr.obj.enabled - Enabled boolean
 *     @param {string} arr.obj.slug - Slug to be used in the returned array
 * @returns {Array} new mapped array containing objects of slug key:values
 */
export function mapEnabledToSlug (arr) {
  return arr
    .filter(function(item) { 
      // Filter so we have only enabled items
      return item.enabled;
    })
    .map(function(item) {
      // map the new array
      return { slug: item.slug };
    });
}


// WEBPACK FOOTER //
// ./resources/assets/js/app/store/services/mapEnabledToSlug.js